import React from 'react';
import PropTypes from 'prop-types';
import Card from './Card';
import useRssFeed from '../../common/hooks/useRssFeed';
import { SUCCESS } from '../../common/constants/viewStates';
import ViewState from '../../common/components/ViewState';

function Layout1(props) {
  const { rssFeedUrl, env, staticContent, locale, renderMode, isPrimaryLight, businessName } =
    props;
  const { viewState, podcast } = useRssFeed({
    env,
    rssFeedUrl,
    renderMode,
    limit: '1',
    businessName,
    staticContent
  });

  return viewState === SUCCESS ? (
    <Card
      locale={ locale }
      staticContent={ staticContent }
      episode={ podcast.episodes[0] }
      podcastTitle={ podcast.title }
      link={ podcast.link }
      podcastImage={ podcast.image }
      isPrimaryLight={ isPrimaryLight }
    />
  ) : (
    <ViewState viewState={ viewState } staticContent={ staticContent } renderMode={ renderMode } />
  );
}

Layout1.propTypes = {
  episodes: PropTypes.any,
  link: PropTypes.string,
  title: PropTypes.string,
  locale: PropTypes.string,
  staticContent: PropTypes.object,
  env: PropTypes.string,
  rssFeedUrl: PropTypes.string,
  renderMode: PropTypes.string,
  isPrimaryLight: PropTypes.bool,
  businessName: PropTypes.string
};

export default Layout1;
